module.exports = __webpack_public_path__ + "static/media/screen1.1b6a2028.png";